import React, { useState, useEffect } from "react";
import { isMobile } from "react-device-detect";
import { useResizeDetector } from "react-resize-detector";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import axios from "axios";
import { StyledDiv, Header, BoldText } from "./styles";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    partialVisibilityGutter: 0,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    partialVisibilityGutter: 0,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    partialVisibilityGutter: 0,
  },
};

export const Posts = () => {
  const [ythPosts, setYTHPosts] = useState([]);
  const { width, ref } = useResizeDetector();
  let device = isMobile ? "mobile" : "desktop";
  if (width <= 464) {
    device = "mobile";
  } else if (width <= 1024) {
    device = "tablet";
  } else {
    device = "desktop";
  }

  useEffect(() => {
    //Get the posts from a JSON file hosted in the cdn
    async function getit() {
      try {
        let post = await axios(
          process.env.REACT_APP_YTH_POSTS
        );
        setYTHPosts(post.data);
      } catch (err) {
        console.log(err);
      }
    }
    getit();
  }, []);

  return (
    <StyledDiv ref={ref}>
      <Header>
        <BoldText>Sample #MyTrueHome #SunWestMortgage Posts</BoldText>
      </Header>
      {/* {console.log(ythPosts)} */}
      <Container>
        <Row className="justify-content-center">
          {ythPosts ? (
            <Col md={8} className="text-center">
              <Carousel
                responsive={responsive}
                ssr
                showDots={false}
                minimumTouchDrag={80}
                slidesToSlide={1}
                partialVisibile={true}
                infinite={true}
                containerClass="container-with-dots"
                itemClass="image-item"
                className="text-center"
                deviceType={device}
                autoPlay={true}
                autoPlaySpeed={3000}
              >
                {ythPosts.map((item) => {
                    return (
                        <>
                        {item.url ? 
                            <a
                                key={item.url}
                                href={item.link}
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img
                                    className="img-thumbnail"
                                    draggable={false}
                                    style={{ position: "relative" }}
                                    src={item.url}
                                    alt={""}
                                />
                            </a>
                        : ""}
                        </>
                    );
                })}
              </Carousel>
              <h4 className="posts-footer-text">
                Don't forget to put both hash tags on your posts:{" "}
                <span className="hashTagPost">#MyTrueHome</span> and{" "}
                <span className="hashTagPost">#SunWestMortgage</span>
              </h4>
            </Col>
          ) : null}
        </Row>
      </Container>
    </StyledDiv>
  );
};
